module.exports = __webpack_public_path__ + "img/instagram-post.bfe71e22.svg";